import React, { useState, useEffect } from 'react';
import {  history } from 'ice';
import { Spin } from 'antd';
import ProLayout from '@ant-design/pro-layout';
import store from '@/store';
import { asideMenuConfig } from '@/menuConfig';
import logo from '@/assets/logo.png';
import { PUBLIC_ROUTES, ROUTE_LOGIN, ROUTE_TELE_MONITORING } from '@/constants';
import monsole from '@/utils/monsole';
import { isMaikaPreviewEnabled } from '@/utils/maika';

export default function Entry(props: {
  children: React.ReactNode;
  pathname: string;
  appLeave: { path: string };
  appEnter: { path: string };
}) {
  const { pathname, children, appLeave, appEnter } = props;
  const isMaikaPreview = isMaikaPreviewEnabled();
  const [loading, setLoading] = useState(true);
  const [isFetchedUserInfo, setIsFetchedUserInfo] = useState(false);
  const [userInfo, setUserInfo] = useState(store.getState().user.currentUser);

  // 订阅 store 变化
  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setUserInfo(store.getState().user.currentUser);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    console.log('== app leave ==', appLeave);
  }, [appLeave]);

  useEffect(() => {
    console.log('== app enter ==', appEnter);
  }, [appEnter]);

  // 拉取用户信息
  useEffect(() => {
    const loadUserData = async () => {
      if (PUBLIC_ROUTES.includes(pathname) || isMaikaPreview || isFetchedUserInfo) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        await store.dispatch.user.asyncGetUserInfo();
        // ice-store 的 dispatch 在 effect 内部抛异常时会静默吞掉错误（resolved 而非 rejected），
        // 因此不能只依赖 catch，还需要检查 userId 是否真正写入了 store。
        if (!store.getState().user.currentUser.userId) {
          // 携带当前 URL 作为 redirect 参数
          const currentPath = window.location.pathname + window.location.search;
          window.location.href = `${ROUTE_LOGIN}?redirect=${encodeURIComponent(currentPath)}`;
          return;
        }
        setLoading(false);
        setIsFetchedUserInfo(true);
      } catch {
        // 携带当前 URL 作为 redirect 参数
        const currentPath = window.location.pathname + window.location.search;
        window.location.href = `${ROUTE_LOGIN}?redirect=${encodeURIComponent(currentPath)}`;
      }
    };

    if (userInfo.userId) {
      setLoading(false);
    } else {
      loadUserData();
    }
  }, [pathname, isFetchedUserInfo, isMaikaPreview]);

  // 用户信息就绪后同步到 monsole（保证后续日志带有 user_name / user_id / run_mode）
  useEffect(() => {
    if (!isMaikaPreview && userInfo.userId) {
      monsole.setUser({ userName: userInfo.userName, userId: userInfo.userId, run_mode: ENV });
      monsole.initErrorCapture();
    }
  }, [userInfo.userId, isMaikaPreview]);

  // 登录状态下访问根路径，跳转到 tele-monitoring
  useEffect(() => {
    if (pathname === '/' && userInfo.userId) {
      history?.replace(ROUTE_TELE_MONITORING);
    }
  }, [pathname, userInfo.userId]);

  // 公开页面直接渲染，不包裹布局
  if (PUBLIC_ROUTES.includes(pathname) || isMaikaPreview) {
    return <>{children}</>;
  }

  // 加载中
  if (loading) {
    return (
      <div style={{ paddingTop: 200, textAlign: 'center' }}>
        <Spin size="large" spinning />
      </div>
    );
  }


  return (
    <ProLayout
      menu={{ defaultOpenAll: true }}
      logo={<img src={logo} alt="logo" />}
      title="TOS"
      location={{ pathname }}
      layout="mix"
      headerRender={ false }
      menuRender={ false }
      ErrorBoundary={false}
      menuDataRender={() => asideMenuConfig}
      menuItemRender={(item: any, defaultDom: React.ReactNode) => {
        if (!item.path) return defaultDom;
        return (
          <span onClick={() => history?.push(item.path)}>
            {defaultDom}
          </span>
        );
      }}
      footerRender={false}
      contentStyle={
        pathname.startsWith('/pad') || pathname.startsWith('/main')
          ? { padding: 0, height: '100vh', overflow: 'hidden' }
          : { minHeight: 500 }
      }
    >
      {children}
    </ProLayout>
  );
}
